import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Icon, Input, Button } from 'antd';
import PlayerToken from './PlayerToken';
import '../../combinedStyles';
import playersService from '../../services/playersService';
import store from '../../reducers/store';

const numberOfPlayersToDisplay = 7;

class SearchProspects extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searchValue: '',
      displayedPlayerArray: [],
    };
  }

  componentWillMount() {
    if (
      typeof this.props.displayedUser.filters === 'undefined' ||
      this.props.displayedUser.filters.length === 0
    ) {
      return;
    }

    this.setState({
      trackedPlayers: this.props.displayedUser.filters.filter(
        (f) => f.filterCategory.name === 'trackedProspect'
      )[0],
    });
  }

  componentWillReceiveProps(nextProps) {
    if (
      typeof nextProps.displayedUser.filters === 'undefined' ||
      nextProps.displayedUser.filters.length === 0
    ) {
      return;
    }

    this.setState({
      trackedPlayers: nextProps.displayedUser.filters.filter(
        (f) => f.filterCategory.name === 'trackedProspect'
      )[0],
    });
    if (nextProps.active == false) {
      if (this.props.players.length !== 0) {
        store.dispatch({ type: 'UPDATE_PLAYERS', players: [] });
      }

      this.setState({
        searchValue: '',
        displayedPlayerArray: [],
        numberOfPlayersToDisplay: 5,
      });
    }
  }

  handlesearchValueChange(event) {
    var newSearchValue = event.target.value;
    if (newSearchValue == '') {
      this.setState({
        searchValue: newSearchValue,
      });
      return;
    }
    playersService.cancelCall('new search');
    playersService.getPlayers(newSearchValue);

    this.setState({
      searchValue: newSearchValue,
    });
  }

  render() {
    // console.log('state', this.state.trackedPlayers)
    const Search = Input.Search;

    var tokens = this.props.players.map((player, index) => {
      // console.log('player', player)
      var tracked = false;
      var hidden = player.hidden;
      if (
        this.props.trackedPlayers.findIndex((trackedPlayer) => {
          return trackedPlayer.id === player.id;
        }) > -1
      ) {
        // console.log('player is tracked')
        tracked = true;
      }
      return (
        <div className='playerDiv' key={'searchDiv' + player.id}>
          <PlayerToken
            trackedPlayers={this.state.trackedPlayers}
            active={true}
            tracked={tracked}
            hidden={hidden}
            type='searchPlayers'
            search={true}
            key={player.id}
            playerObj={player}></PlayerToken>
        </div>
      );
    });
    return (
      <div className='searchDiv'>
        <Search
          style={{ width: '50%' }}
          className='playerSearch'
          placeholder='Search Players'
          onChange={this.handlesearchValueChange.bind(this)}
          value={this.state.searchValue}></Search>
        {tokens}
      </div>
    );
  }
}

function mapStoreToProps(storeState) {
  return {
    allPlayers: storeState.lists.allPlayers,
    trackedPlayers: storeState.main.trackedPlayers,
    hiddenPlayers: storeState.lists.hiddenPlayers,
    players: storeState.main.players,
    displayedUser: storeState.main.displayedUser,
  };
}

export default connect(mapStoreToProps)(SearchProspects);



// WEBPACK FOOTER //
// ./src/components/trackedProspects/SearchProspects.js